// Bilingual dictionary (ES / EN)
export const TRANSLATIONS = {
  es: {
    // Common
    "app.name": "SDM Customer Engagement Console",
    "app.tagline": "Panel BDC · Servicio al cliente",
    "common.search": "Buscar",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.create": "Crear",
    "common.loading": "Cargando…",
    "common.empty": "Sin resultados",
    "common.all": "Todos",
    "common.filter": "Filtrar",
    "common.actions": "Acciones",
    "common.status": "Estado",
    "common.date": "Fecha",
    "common.name": "Nombre",
    "common.email": "Email",
    "common.phone": "Teléfono",
    "common.role": "Rol",
    "common.channel": "Canal",
    "common.branch": "Sucursal",
    "common.send": "Enviar",
    "common.confirm": "Confirmar",
    "common.close": "Cerrar",
    "common.assign": "Asignar",
    "common.notes": "Notas",
    "common.new": "Nuevo",
    "common.view": "Ver",
    "common.back": "Volver",

    // Auth
    "auth.login": "Iniciar sesión",
    "auth.logout": "Cerrar sesión",
    "auth.email": "Correo electrónico",
    "auth.password": "Contraseña",
    "auth.signin": "Entrar",
    "auth.welcome": "Bienvenido",
    "auth.subtitle": "Panel de control unificado para Ventas, Seminuevos, Servicio y BDC.",
    "auth.demo": "Credenciales de demostración",
    "auth.error": "Credenciales inválidas",

    // Sidebar
    "nav.dashboard": "Panel",
    "nav.inbox": "Bandeja Omnicanal",
    "nav.supervisor": "Supervisión",
    "nav.leads": "Contactos",
    "nav.workshop": "Citas de Taller",
    "nav.service": "Citas de Taller",
    "nav.parts": "Repuestos y Accesorios",
    "nav.financing": "Financiamiento",
    "nav.webhooks": "Webhooks CRM",
    "nav.integrations": "Integraciones",
    "nav.kb": "Base de Conocimiento",
    "nav.vehicles": "Catálogo de Vehículos",
    "nav.agents": "Agentes",
    "nav.settings": "Configuración",
    "nav.widget": "Widget Web",
    "nav.campaigns": "Campañas",
    "nav.demo": "Demo",
    "nav.training": "Entrenamiento",
    "nav.docs": "Documentación",

    // Dashboard
    "dash.title": "Panel Ejecutivo",
    "dash.subtitle": "Visión general de operaciones — tiempo real.",
    "dash.total_conv": "Conversaciones totales",
    "dash.leads": "Leads activos",
    "dash.service_req": "Solicitudes servicio",
    "dash.avg_score": "Score promedio",
    "dash.open": "Abiertas",
    "dash.escalated": "Escaladas",
    "dash.conversion": "Conversión",
    "dash.channel_dist": "Distribución por canal",
    "dash.volume": "Volumen últimos 7 días",
    "dash.top_vehicles": "Vehículos más solicitados",
    "dash.intent": "Leads por intención",
    "dash.leaderboard": "Rendimiento del equipo",

    // Inbox
    "inbox.title": "Bandeja Omnicanal",
    "inbox.subtitle": "Todas las conversaciones — WhatsApp, Instagram y Messenger.",
    "inbox.all": "Todas",
    "inbox.open": "Abiertas",
    "inbox.escalated": "Escaladas",
    "inbox.resolved": "Resueltas",
    "inbox.select_conv": "Selecciona una conversación",
    "inbox.no_selection": "Elige una conversación de la lista para ver los mensajes.",
    "inbox.compose": "Escribe tu respuesta…",
    "inbox.suggest_ai": "Sugerir con IA",
    "inbox.summarize": "Resumir",
    "inbox.mark_resolved": "Marcar resuelto",
    "inbox.escalate": "Escalar",
    "inbox.customer": "Cliente",
    "inbox.summary": "Resumen",
    "inbox.suggestions": "Respuestas sugeridas",

    // Leads / Contactos (Spanish rebrand Oct 2026 — API still uses "leads")
    "leads.title": "Contactos",
    "leads.subtitle": "Contactos calificados por IA con scoring automático.",
    "leads.high": "Alto (80-100)",
    "leads.medium": "Medio (50-79)",
    "leads.low": "Bajo (0-49)",
    "leads.score": "Score",
    "leads.intent": "Intención",
    "leads.brand": "Marca / Modelo",
    "leads.timeline": "Plazo",
    "leads.assigned": "Asignado",
    "leads.signals": "Señales de compra",
    "leads.action": "Acción recomendada",
    "leads.rescore": "Recalcular Score",
    "leads.new": "Nuevo Contacto",

    // Service
    "svc.title": "Citas de Taller",
    "svc.subtitle": "Solicitudes de cita — se sincronizan con SAP (disponibilidad en vivo).",
    "svc.pending": "Pendientes",
    "svc.confirmed": "Confirmadas",
    "svc.completed": "Completadas",
    "svc.vehicle": "Vehículo",
    "svc.plate": "Placa",
    "svc.type": "Tipo",
    "svc.preferred": "Fecha preferida",
    "svc.description": "Descripción",
    "svc.confirm_appt": "Confirmar cita",
    "svc.new": "Nueva Solicitud",

    // KB
    "kb.title": "Base de Conocimiento",
    "kb.subtitle": "Fuente de verdad para el asistente IA (RAG).",
    "kb.new": "Nuevo Documento",
    "kb.category": "Categoría",
    "kb.tags": "Etiquetas",
    "kb.content": "Contenido",

    // Vehicles
    "veh.title": "Catálogo de Vehículos",
    "veh.subtitle": "Inventario nuevo y Seminuevos.",
    "veh.new": "Nuevos",
    "veh.used": "Seminuevos",
    "veh.price": "Precio",
    "veh.mileage": "Kilometraje",
    "veh.transmission": "Transmisión",
    "veh.add": "Agregar Vehículo",

    // Agents
    "ag.title": "Agentes",
    "ag.subtitle": "Equipo y roles con acceso a la plataforma.",
    "ag.presence": "Presencia",
    "ag.available": "Disponible",
    "ag.busy": "Ocupado",
    "ag.away": "Ausente",
    "ag.offline": "Desconectado",
    "ag.invite": "Invitar Agente",

    // Widget
    "wg.title": "Widget de Chat Web",
    "wg.subtitle": "Previsualización — Prueba el asistente en tiempo real.",
    "wg.placeholder": "Escribe tu pregunta…",
    "wg.hello": "¡Hola! Soy SDM Concierge, tu asistente de Santo Domingo Motors. ¿En qué te puedo ayudar hoy?",

    // Settings
    "set.title": "Configuración",
    "set.subtitle": "Preferencias del sistema, IA e integraciones.",
    "set.theme": "Tema",
    "set.language": "Idioma",
    "set.integrations": "Integraciones",
    "set.routing": "Enrutamiento",
    "set.ai": "IA",
  },
  en: {
    "app.name": "SDM Customer Engagement Console",
    "app.tagline": "BDC customer service console",
    "common.search": "Search",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.create": "Create",
    "common.loading": "Loading…",
    "common.empty": "No results",
    "common.all": "All",
    "common.filter": "Filter",
    "common.actions": "Actions",
    "common.status": "Status",
    "common.date": "Date",
    "common.name": "Name",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.role": "Role",
    "common.channel": "Channel",
    "common.branch": "Branch",
    "common.send": "Send",
    "common.confirm": "Confirm",
    "common.close": "Close",
    "common.assign": "Assign",
    "common.notes": "Notes",
    "common.new": "New",
    "common.view": "View",
    "common.back": "Back",

    "auth.login": "Login",
    "auth.logout": "Logout",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signin": "Sign in",
    "auth.welcome": "Welcome",
    "auth.subtitle": "Unified control center for Sales, Pre-owned, Service and BDC.",
    "auth.demo": "Demo credentials",
    "auth.error": "Invalid credentials",

    "nav.dashboard": "Dashboard",
    "nav.inbox": "Omnichannel Inbox",
    "nav.supervisor": "Supervision",
    "nav.leads": "Contacts",
    "nav.workshop": "Workshop Appointments",
    "nav.service": "Workshop Appointments",
    "nav.parts": "Parts & Accessories",
    "nav.financing": "Financing",
    "nav.webhooks": "CRM Webhooks",
    "nav.integrations": "Integrations",
    "nav.kb": "Knowledge Base",
    "nav.vehicles": "Vehicle Catalog",
    "nav.agents": "Agents",
    "nav.settings": "Settings",
    "nav.widget": "Web Widget",
    "nav.campaigns": "Campaigns",
    "nav.demo": "Demo",
    "nav.training": "Training",
    "nav.docs": "Documentation",

    "dash.title": "Executive Dashboard",
    "dash.subtitle": "Operations at a glance — realtime.",
    "dash.total_conv": "Total conversations",
    "dash.leads": "Active leads",
    "dash.service_req": "Service requests",
    "dash.avg_score": "Avg lead score",
    "dash.open": "Open",
    "dash.escalated": "Escalated",
    "dash.conversion": "Conversion",
    "dash.channel_dist": "Channel distribution",
    "dash.volume": "7-day volume",
    "dash.top_vehicles": "Most requested vehicles",
    "dash.intent": "Leads by intent",
    "dash.leaderboard": "Team performance",

    "inbox.title": "Omnichannel Inbox",
    "inbox.subtitle": "All conversations — WhatsApp, Instagram and Messenger.",
    "inbox.all": "All",
    "inbox.open": "Open",
    "inbox.escalated": "Escalated",
    "inbox.resolved": "Resolved",
    "inbox.select_conv": "Select a conversation",
    "inbox.no_selection": "Pick a conversation from the list to see the thread.",
    "inbox.compose": "Type your reply…",
    "inbox.suggest_ai": "AI suggest",
    "inbox.summarize": "Summarize",
    "inbox.mark_resolved": "Mark resolved",
    "inbox.escalate": "Escalate",
    "inbox.customer": "Customer",
    "inbox.summary": "Summary",
    "inbox.suggestions": "Suggested replies",

    "leads.title": "Contacts",
    "leads.subtitle": "AI-qualified contacts with automatic scoring.",
    "leads.high": "High (80-100)",
    "leads.medium": "Medium (50-79)",
    "leads.low": "Low (0-49)",
    "leads.score": "Score",
    "leads.intent": "Intent",
    "leads.brand": "Brand / Model",
    "leads.timeline": "Timeline",
    "leads.assigned": "Assigned",
    "leads.signals": "Buying signals",
    "leads.action": "Recommended action",
    "leads.rescore": "Recompute score",
    "leads.new": "New Contact",

    "svc.title": "Workshop Appointments",
    "svc.subtitle": "Appointment requests — synced with SAP (live availability).",
    "svc.pending": "Pending",
    "svc.confirmed": "Confirmed",
    "svc.completed": "Completed",
    "svc.vehicle": "Vehicle",
    "svc.plate": "Plate",
    "svc.type": "Type",
    "svc.preferred": "Preferred date",
    "svc.description": "Description",
    "svc.confirm_appt": "Confirm appointment",
    "svc.new": "New Request",

    "kb.title": "Knowledge Base",
    "kb.subtitle": "Source of truth for the AI assistant (RAG).",
    "kb.new": "New document",
    "kb.category": "Category",
    "kb.tags": "Tags",
    "kb.content": "Content",

    "veh.title": "Vehicle Catalog",
    "veh.subtitle": "New inventory & Pre-owned marketplace.",
    "veh.new": "New",
    "veh.used": "Pre-owned",
    "veh.price": "Price",
    "veh.mileage": "Mileage",
    "veh.transmission": "Transmission",
    "veh.add": "Add vehicle",

    "ag.title": "Agents",
    "ag.subtitle": "Team members and roles with platform access.",
    "ag.presence": "Presence",
    "ag.available": "Available",
    "ag.busy": "Busy",
    "ag.away": "Away",
    "ag.offline": "Offline",
    "ag.invite": "Invite agent",

    "wg.title": "Web Chat Widget",
    "wg.subtitle": "Live preview — try the AI assistant.",
    "wg.placeholder": "Type your question…",
    "wg.hello": "Hi! I'm SDM Concierge, your Santo Domingo Motors assistant. How can I help you today?",

    "set.title": "Settings",
    "set.subtitle": "System preferences, AI and integrations.",
    "set.theme": "Theme",
    "set.language": "Language",
    "set.integrations": "Integrations",
    "set.routing": "Routing",
    "set.ai": "AI",
  },
};
